import { render } from "./InitializeFeedback.vue?vue&type=template&id=4d9138fb"
import script from "./InitializeFeedback.vue?vue&type=script&lang=js"
export * from "./InitializeFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__